import { render, staticRenderFns } from "./Datos.vue?vue&type=template&id=5c3810f6"
import script from "./Datos.vue?vue&type=script&lang=js"
export * from "./Datos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports